import { Grid } from '@material-ui/core';
import { Dispatch, useContext, useState, VFC } from 'react';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';
import { useHooks } from './useHooks';
import { useStyles } from './useStyles';
import { SiteProcessSelectfield } from '../../input/ProcessSelectfield';
import { TEditAttendancForm } from '../../../../types/attendancManage';
import { BaseModal } from '../../../molecules/BaseModal';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';
import { AttendanceDeleteModal } from '../AttendanceDeleteModal';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  id: number;
  constructId: number;
  setIsLoadingGantt: Dispatch<boolean>;
};

export const AttendanceEditModal: VFC<Props> = props => {
  const { isOpen, setIsOpen, id, constructId, setIsLoadingGantt } = props;
  const classes = useStyles();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const methods: UseFormReturn<TEditAttendancForm> = useForm({
    reValidateMode: 'onSubmit'
  });
  const {
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const {
    cancelUpdate,
    update,
    businessTypeList,
    employeeList,
    partnerList,
    isOpenDeleteModal,
    setIsOpenDeleteModal,
    handleDeleteSubmit,
    selectBusinessType,
    setSelectBusinessType
  } = useHooks({
    setIsOpen,
    getValues,
    setValue,
    reset,
    isOpen,
    id,
    constructId,
    setIsLoadingGantt
  });

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(update, (erros: any) => {})}
      handleCancelSubmit={cancelUpdate}
      title={'人工編集'}
      buttonCaption={'更新する'}
      cancelButtonCaption={'キャンセル'}
      subDeleteButton={true}
      handleDeleteSubmit={handleDeleteSubmit}
      editFlg={authInfo?.role != ROLE['OUTSIDE_PARTNER']}
    >
      <FormProvider {...methods}>
        {/* 種別 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>種別*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <SiteProcessSelectfield
            name='business_type'
            listDatas={businessTypeList}
            className={`${classes.input} ${classes.gridItem}`}
            onChange={(e: any) => setSelectBusinessType(e)}
            required={true}
            errorMessage={errors?.business_type?.message}
          />
        </Grid>
        {selectBusinessType.value == 1 && (
          <>
            <Grid item xs={10} md={3} className={classes.gridItem}>
              <label className={classes.label}>担当者*</label>
            </Grid>
            <Grid item xs={10} md={7}>
              <SiteProcessSelectfield
                name='user_id'
                listDatas={employeeList}
                className={`${classes.input} ${classes.gridItem}`}
                required={false}
                errorMessage={errors?.user_id?.message}
              />
            </Grid>
          </>
        )}
        {/* /担当者 */}
        {/* 企業名 */}
        {selectBusinessType.value == 2 && (
          <>
            <Grid item xs={10} md={3} className={classes.gridItem}>
              <label className={classes.label}>企業名*</label>
            </Grid>
            <Grid item xs={10} md={7}>
              <SiteProcessSelectfield
                name='partner_id'
                listDatas={partnerList}
                className={`${classes.input} ${classes.gridItem}`}
                required={false}
                errorMessage={errors?.partner_id?.message}
              />
            </Grid>
          </>
        )}
        {/* /企業名 */}
      </FormProvider>
      {/* 削除モーダル */}
      <AttendanceDeleteModal
        isOpen={isOpenDeleteModal}
        id={id}
        setIsEditModalOpen={setIsOpen}
        setIsOpen={setIsOpenDeleteModal}
        constructId={constructId}
        getValues={getValues}
      />
    </BaseModal>
  );
};
